<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item.name}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div class="metter">
      <el-table ref="JLTable" :key="tableKey" :data="voteData" border style="width:100%">
        <el-table-column min-width="140px" :label="'名称'" prop="title" show-overflow-tooltip>
          <template slot-scope="scope">
            <span type="primary" size="mini" class="title1deta">{{scope.row.title}}</span>
          </template>
        </el-table-column>

        <el-table-column width="100px" :label="'类型'" align="center" prop="catedicname" show-overflow-tooltip></el-table-column>
        <el-table-column width="90px" :label="'状态'" align="center" prop="stateName"></el-table-column>
        <el-table-column width="100px" :label="'开始时间'" align="center" prop="starttime">
          <template slot-scope="scope">
            <span>{{scope.row.starttime.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column width="100px" :label="'结束时间'" align="center" prop="endtime">
          <template slot-scope="scope">
            <span>{{scope.row.endtime.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="'操作'"
          width="160"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <!-- 进行中没有测评的 -->
            <el-button
              type="primary"
              plain
              size="mini"
              v-if="scope.row.state==2 && scope.row.submit_status ==0"
              @click="questionget(scope.row.pollid)"
            >测评</el-button>
            <!-- 进行中已经测评的 -->
            <el-button
              type="primary"
              plain
              size="mini"
              @click="look(scope.row)"
              v-else-if=" scope.row.submit_status ==1"
            >结果</el-button>

            <el-button
              type="primary"
              plain
              size="mini"
              disabled
              v-else-if="scope.row.state==3 && scope.row.submit_status ==0"
            >未提交</el-button>

            <!-- 没开始的 -->
            <el-button type="info" plain size="mini" v-if="scope.row.state==1" disabled>未开始</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div v-else style="margin-top:120px">
      <nodata></nodata>
    </div>-->
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        layout="total, prev, pager, next"
        :total="total1"
        v-if="total1>0"
      ></el-pagination>
    </div>

    <el-dialog
      class="dialog-mini"
      title="测评结果"
      :visible.sync="innerVisibleVideo"
      append-to-body
      v-if="innerVisibleVideo"
    >
      <iamVoteQuestiong :topicId="topicId" v-if="innerVisibleVideo"></iamVoteQuestiong>
    </el-dialog>
  </div>
</template>
<script>
import * as PersonCenter from '@/api/personcenter/index';
import iamVoteQuestiong from './component/iamVoteQuestiong';
export default {
  components: { iamVoteQuestiong },
  data() {
    return {
      innerVisibleVideo: false,
      tableKey: 0,
      labledata: [
        { name: '全部', id: 0 },
        { name: '未开始', id: 1 },
        { name: '进行中', id: 2 },
        { name: '已结束', id: 3 },
      ],
      currentPage2: 1,
      lableindex: 0,
      total1: 0,
      listQuery: {
        page: 1,
        limit: 8,
        userId: this.$store.state.User.ids,
        type: 0,
      },
      voteData: [],
      topicId: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lableArea(index, item) {
      this.listQuery.type = item.id;
      this.lableindex = index;
      this.getList();
    },
    getList() {
      PersonCenter.TrainInfoGetMyPoll(this.listQuery).then((res) => {
        this.voteData = res.data;
        this.total1 = res.count;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    look(row) {
      this.topicId = row.pollid;
      this.innerVisibleVideo = true;
    },
    questionget(id) {
      this.$router.push({
        path: '/diaoy/questionget',
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  /* width: 850px; */
}

.nav {
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  border: 1px solid #f2f2f2;
  padding-top: 16px;
  margin-left: 20px;
}

.navfirst {
  font-weight: bold;
  font-size: 16px;
  border-bottom: solid 1px #f2f2f2;
  padding: 0 0 10px 10px;
}
hr {
  margin-top: 10px;
}
.navsecond {
  border-bottom: solid 1px #f2f2f2;
  padding: 10px;
}
.navsecond > div {
  line-height: 30px;
  color: #666;
  font-size: 15px;
}
.navthirt {
  padding: 10px;
  text-align: right;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.navsecondfelx {
  flex: 1;
}
.navseconddf {
  display: flex;
}
.title1deta:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #1492ff;
}
</style>